import {
  ButtonProps as MuiButtonProps,
  ToggleButtonProps,
  buttonClasses as muiButtonClasses,
  getButtonUtilityClass,
} from '@mui/material';

declare module '@mui/material/Button' {
  interface ButtonPropsSizeOverrides {
    extraSmall: true;
  }

  interface ButtonClasses {
    sizeExtraSmall: string;
  }

}

export interface ButtonProps extends Omit<MuiButtonProps, 'variant' | 'color' | 'disableFocusRipple' | 'onChange' | 'component'> {
  /**
   * Substitute for MUI/Button variant and color prop.
   */
  colorVariant?: ButtonColorVariant;
  /**
   * Set true to display spinner inside the button.
   */
  loading?: boolean;
  selected?: boolean;
  classes?: Partial<typeof muiButtonClasses>;
  onChange?: ToggleButtonProps['onChange'];
  component?: React.ElementType;
}

export type ButtonColorVariant = 'primary'
  | 'secondary'
  | 'outlined'
  | 'text'
  | 'textSecondary'
  | 'destructive'
  | 'destructiveOutlined'
  | 'destructiveText'
  | 'inversePrimary'
  | 'inverseOutlined'
  | 'inverseText';

export const buttonClasses = {
  ...muiButtonClasses,
  toggleable: getButtonUtilityClass('toggleable'),
  selected: getButtonUtilityClass('selected'),
  sizeExtraSmall: getButtonUtilityClass('sizeExtraSmall'),
};
